module.exports = __webpack_public_path__ + "img/fujitsu-logo.f00b4f87.svg";